import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

export const getListEvaluasi = createAsyncThunk('/history_evaluasi/content', async () => {
    const userId = localStorage.getItem("userId")
    const response = await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/listManagementEvaluasi/${userId}`, {})
    return response.data;
})

export const dashboardEvaluasiHistorySlice = createSlice({
    name: 'history_evaluasi',
    initialState: {
        isLoading: false,
        history_evaluasi: []
    },

    /*extraReducers: {
        [getListEvaluasi.pending]: state => {
            state.isLoading = true
        },
        [getListEvaluasi.fulfilled]: (state, action) => {
            state.history_evaluasi = action.payload.data
            state.isLoading = false
        },
        [getListEvaluasi.rejected]: state => {
            state.isLoading = false
        },
    }*/
    extraReducers: (builder) => {
        builder
            .addCase(getListEvaluasi.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getListEvaluasi.fulfilled, (state, action) => {
                state.history_evaluasi = action.payload.data;               
                state.isLoading = false;
            })
            .addCase(getListEvaluasi.rejected, (state) => {
                state.isLoading = false;
            });                 
    }           
})

export default dashboardEvaluasiHistorySlice.reducer